export const K6_QUERY_PARAM_NAME = "origin";
export const K6_QUERY_PARAM_VALUE = "k6";
export const DISABLE_GTM_COOKIE_NAME = "disable-gtm";

export const GTM_CONTAINER_ID = "GTM-PS3SJ2";
